import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=8585ce6e&scoped=true&"
import script from "./ChatMessage.vue?vue&type=script&lang=ts&"
export * from "./ChatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=8585ce6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8585ce6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VCard,VDialog,VDivider,VIcon,VImg})
